<doc>
  @desc:   缺省图
  @author:  
</doc>
<template>
  <div class="default-warp" :style="styles">
    <template v-if="$slots.default"><slot /></template>
    <template v-else>
      <img
        class="image"
        :style="imageStyles"
        :src="image"
      />
      <div class="text" :style="textStyles">{{ text }}</div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    // 最外层盒子样式
    styles: {
      type: Object,
      default() {
        return {
          
        };
      },
    },
    imageStyles: {
      type: Object,
      default() {
        return {
          
        };
      },
    },
    text: {
      type: String,
      default() {
        return this.langConfig.txtLang[this.langConfig.curLang]['NO_DATA'];
      },
    },
    textStyles: {
      type: Object,
      default() {
        return {
        };
      },
    },
    image: {
      type: String,
      default: require(`@/assets/images/no-data.svg`)
    }
  },

  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.default-warp {
  color: @color_595959;
  padding: 90px 0 30px;
  margin: auto;
  text-align: center;
  .image {
    display: block;
    width: 300px;
    height: 195px;
    margin: 0 auto 10px;
  }
  .text {
    font-size: 18px;
    font-family: @font_family_PublicSans_Regular;
  }
}
/* phone */
@media screen and (max-width: 767px) {
  .default-warp {
    padding: .3rem 0 .3rem;
    .image {
      width: 1.66rem;
      height: 1.61rem;
      margin: 0 auto .1rem;
    }
    .text {
      font-size: .16rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// ./src/components/defaultPic.vue